<template>
  <div class="view-more" v-if="payload_num<max_num">
    <span @click="click_method && click_method()">{{$t('filter.view_more')}}</span>
  </div>
</template>
<script>
export default {
  props: {
    click_method: {
      type: Function,
      require: true,
    },
    payload_num: {
      type: Number,
      require:true
    },
    max_num: {
      type: Number,
      default: 99999999999999999999999,
    },
  },
};
</script>
<style scoped lang='scss'>
.view-more {
  color: #606266;
  padding: 5px 0;
  font-size: 14px;
  span {
    cursor: pointer;
  }
}
</style>